/* 
"Obliqua". NFT art project created by Daniel Aguilar, 2023
Licensed under NFT License 2.0
See LICENSE.md for details
*/


import p5 from 'p5'
import p5grain from '../libs/p5.grain.js'
import {detect} from 'detect-browser'
import gn from 'genart'
import Pelusa2 from './tools/Pelusa2.js';
import Layer from './tools/Layer.js';
import Brancher from './tools/Brancher.js';
import Config from './Config.js';
const pick = gn.math.randomElementFromArray;

import p5Svg from "p5.js-svg"

p5Svg(p5);


Math.random = gn.math.random;
window.gn = gn;
console.log("fxhash seed: ", fxhash );   // the 64 chars hex number fed to your algorithm

window.branchers = [];



window.pixelDensity = 1;
window.canvasScale = 1;
window.Config = Config;

let urlParams = new URLSearchParams(window.location.search)

$fx.params([  
  {
    id: "orientation",
    name: "Orientation",
    type: "select",
    default: urlParams.get('orientation') || "Portrait",
    options: {
      options: ["Landscape", "Portrait", "Square"],
    }
  },
  {
    id: "seedMode",
    name: "Seed Mode",
    type: "select",
    default: urlParams.get('seedMode') || "Grid Lateral",
    options: {
      options: Config.seedModes.map( item=>item.name ),
    }
  },
  {
    id: "aperture",
    name: "Aperture",
    type: "select",
    default: urlParams.get('aperture') || "Iso Triangular",
    options: {
      options: Config.aperture.map( item=>item.name ),
    }
  },
  {
    id: "concentration",
    name: "Concentration",
    type: "select",
    default: urlParams.get('concentration') || "Random",
    options: {
      options: Config.concentration.map( item=>item.name ),
    }
  },
  {
    id: "palette",
    name: "Color Palette",
    type: "select",
    default: urlParams.get('palette') || "Muddy Mark", 
    options: {
      options: Config.palettes.map( item=>item.name ),
    }
  },
  {
    id: "colorDistribute",
    name: "Color Distribute",
    type: "select",
    default: urlParams.get('colorDistribute') || "Bottom Up",
    options: {
      options: Config.colorDistribute.map( item=>item.name ),
    }
  },
  {
    id: "paintMode",
    name: "Paint Mode",
    type: "select",
    default: urlParams.get('paintMode') || "Mixed",
    options: {
      options: Config.paintModes.map( item=>item.name ),
    }
  },
  {
    id: "contrast",
    name: "Contrast",
    type: "number",
    default: urlParams.get('contrast') || 1,
    options: {
      min: 0.7,
      max: 1.3,
      step: 0.1,
    },
  },
  {
    id: "saturate",
    name: "Saturate",
    type: "number",
    default: urlParams.get('saturate') || 1,
    options: {
      min: 0.5,
      max: 1.5,
      step: 0.1,
    },
  },
  {
    id: "brightness",
    name: "Brightness",
    type: "number",
    default: urlParams.get('brightness') || 1,
    options: {
      min: 1,
      max: 1.3,
      step: 0.05,
    },
  },
  /* {
    id: "hue",
    name: "Hue",
    type: "number",
    default: urlParams.get('hue') || 0,
    options: {
      min: -30,
      max: 30,
      step: 1,
    },
  }, */
  /* {
    id: "backdropSketch",
    name: "Backdrop Sketch",
    type: "boolean",
    default: true,
  },  
  {
    id: "glow",
    name: "Glow",
    type: "boolean",
    default: true,
  },
  {
    id: "grain",
    name: "Grain",
    type: "boolean",
    default: true,
  },
  {
    id: "shadow",
    name: "Shadow",
    type: "boolean",
    default: true,
  },
  {
    id: "worn",
    name: "Worn",
    type: "boolean",
    default: true,
  },
  {
    id: "frame",
    name: "Frame",
    type: "boolean",
    default: true,
  }, */
  
]);

let pieceWidth, pieceHeight;
if( $fx.getParam("orientation") == "Landscape" ){
  pieceWidth = 2970;
  pieceHeight = 2100;
}else if( $fx.getParam("orientation") == "Portrait" ){
  pieceWidth = 2100;
  pieceHeight = 2970;
}else{
  pieceWidth = 2970;
  pieceHeight = 2970;
}

const cX = pieceWidth / 2;
const cY = pieceHeight / 2;

window.pieceWidth = pieceWidth;
window.pieceHeight = pieceHeight;
window.cX = cX;
window.cY = cY;


function generateOptions( options ){
  let result = {
    margin: -100, 
    orientation: options.orientation, 
    contrast: options.contrast, 
    //hue: options.hue, 
    saturate: options.saturate, 
    brightness: options.brightness, 
    palette: Config.palettes.find( item=>{ return item.name == options.palette } ), 
    aperture: Config.aperture.find( item=>{ return item.name == options.aperture } ), 
    concentration: Config.concentration.find( item=>{ return item.name == options.concentration } ), 
    seedMode: Config.seedModes.find( item=>{ return item.name == options.seedMode } ), 
    glow: true,
    backdropSketch: true,
    grain: true,
    shadow: true,
    worn: true,
    frame: true,
    paintMode: Config.paintModes.find( item=>{ return item.name == options.paintMode } ), 
    colorDistribute: Config.colorDistribute.find( item=>{ return item.name == options.colorDistribute } ), 
  }
  return result;
}

let randomFam = function(){
  return {
    orientation: $fx.getParam("orientation") || "Portrait",
    contrast: $fx.getParam("contrast") || 1,
    //hue: $fx.getParam("hue") || 0,
    saturate: $fx.getParam("saturate") || 1,
    brightness: $fx.getParam("brightness") || 1,
    palette:  $fx.getParam("palette") || pick( Config.palettes ).name,
    aperture: $fx.getParam("aperture") || pick( Config.aperture ).name,
    concentration: $fx.getParam("concentration") || pick( Config.concentration ).name,
    seedMode: $fx.getParam("seedMode") || pick( Config.seedModes ).name,
    paintMode: $fx.getParam("paintMode") || pick( Config.paintModes ).name,
    colorDistribute: $fx.getParam("colorDistribute") || pick(Config.colorDistribute).name,
  }
}

window.configOptions = generateOptions( randomFam() );





// --------------------------
const config = window.config = new Config( configOptions );
const stl = window.stl = config.style;

// Define features
window.$fxhashFeatures = {
  orientation: configOptions.orientation,
  seedMode: configOptions.seedMode.name,
  aperture: configOptions.aperture.name,
  concentration: configOptions.concentration.name, 
  palette: configOptions.palette.name,
  colorDistribute: configOptions.colorDistribute.name,
  paintMode: configOptions.paintMode.name,
  contrast: configOptions.contrast, 
  //hue: configOptions.hue, 
  saturate: configOptions.saturate, 
  brightness: configOptions.brightness, 
  /* backdropSketch: configOptions.backdropSketch,
  glow: configOptions.glow,
  grain: configOptions.grain,
  shadow: configOptions.shadow,
  worn: configOptions.worn,
  frame: configOptions.frame, */
};
// --------------------------
let colorPalette = stl.palette;



// Define the app options
let options = window.options = 
{
  margin: configOptions.margin, 
  bgColor: colorPalette.background,
  bgAlpha: 97, 
  palette: colorPalette, 
  blurLevel0: 5,
  blurLevel1: 80,
  blurLevel2: 20,

  brancherConfig: {
    seedLines: stl.getSeeds(), // generateSeedLinesHorizontal( 8, pieceWidth*0.7, pieceHeight*.3, -1000 ),
    style: stl, 
  }
};

//document.getElementById('preloaderBg').style.backgroundColor = options.bgColor;

let shadowPositions = [];
let layers = window.layers = [];




function prepareLayer(){
  
  let pp = p5App;
  let ctx = pp.drawingContext;
  pp.push();
  pp.clear();
  pp.noStroke();
  pp.fill("#00FFEE");
  ctx.globalAlpha = 0;
  pp.rect(0,0,pieceWidth,pieceHeight);
  ctx.globalAlpha = 1;
  pp.pop();  
}

function createLayer( zindex=0, name="Unnamed", opacity=1 ){
  let layer = new Layer( zindex, name, pieceWidth, pieceHeight, colorPalette.background, opacity, true );
  layer.setImage( p5App );
  layers.push( layer );
  return layer;
}

function drawLayers( ){
  p5App.background( colorPalette.background);
  let sortedLayers = layers.sort( (a,b)=>{ return a.zindex < b.zindex ? -1 : 1 } );
  sortedLayers.forEach( layer => {
    drawLayer( layer );
    layer.remove();
  });
}

function drawLayer( layer ){
  let ctx = p5App.drawingContext;
  pp.push();
  pp.drawingContext.globalAlpha = layer.opacity;
  ctx.drawImage( layer.canvas.drawingContext.canvas, 0, 0, layer.canvas.width, layer.canvas.height );
  pp.pop();
}

function resetFxRand(){
  const S=Uint32Array.of(9,7,5,3);
  const R=(a=1)=>a*(a=S[3],S[3]=S[2],S[2]=S[1],a^=a<<11,S[0]^=a^a>>>8^(S[1]=S[0])>>>19,S[0]/2**32);
  [...fxhash+'SOURCERY'].map(c=>R(S[3]^=c.charCodeAt()*23205));
  $fx.rand = fxrand = R
}

function init(){
  resetFxRand();

  window.branchers = [];
  shadowPositions = [];
  layers = [];

  let startTime = Date.now();
  pp.pixelDensity(window.pixelDensity);
  p5grain.setup();  
  
  window.app = new gn.GenArt(pieceWidth, pieceHeight, options );

  let ctx = pp.drawingContext;
  let layer;
  
  prepareLayer();  
  p5App.push();
    
    // --- TRANSLUCENT-BELOW BRANCHER -----
    let brancher;

    // ---- MAIN BRANCHER ----
    brancher = createBrancher("Main");
    if( configOptions.paintMode.name != "Outline" ){
      prepareLayer();
      brancher.drawPolygons();
      drawFrame();
      layer = createLayer( 2, "Main branch fills" );
      if( configOptions.glow ){
        layer.applyBlur( options.blurLevel0, 10 );
      }
    }
    
    prepareLayer();
    brancher.drawSegments();
    drawFrame();
    layer = createLayer( 3, "Main branch segments" );
    if( configOptions.glow ){
      //layer.applyBlur( options.blurLevel0 );
      layer.applyBlur( options.blurLevel2, "10" );
    }
    
    if( configOptions.backdropSketch ){
      brancher = createBrancher("Bg");  
      prepareLayer();
      brancher.drawSegments();
      drawFrame();
      layer = createLayer( 1, "Backdrop Branch segments", .2 );
      
      layer.applyBlur( options.blurLevel0, "00" );
      //layer.applyBlur( options.blurLevel2, "60" );
      layer.applyBlur( options.blurLevel2, "10" );
      
    }

    if( configOptions.shadow )
      createGlobalPelusa();
    

    if( configOptions.worn )
      createPleusaShadow();

  drawLayers();


    ctx.filter = "none";


    applyFilters();
    if( configOptions.grain)
      p5grain.granulateSimple( 10, true );

    let endTime = Date.now();
    let delta = endTime - startTime;    
    console.table( window.$fxhashFeatures );
    console.log( "Artwork build took ", delta, ' milliseconds' );

    p5App.noLoop();
  
}


function createPleusaShadow(){
  
  // ------ PELUSA SHADOWS -------
 prepareLayer();
 shadowPositions = [
  gn.geom.randomPointInCircumference( pieceHeight/2, pieceWidth/2, pieceHeight/2 ),
  gn.geom.randomPointInCircumference( pieceHeight/2, pieceWidth/2, pieceHeight/2 ),
  gn.geom.randomPointInCircumference( pieceHeight/2, pieceWidth/2, pieceHeight/2 ),
 ];
 let shadowSize = gn.math.randInt(900,600);
 for (let i = 0; i < shadowPositions.length; i++) {
   let shadowPos = shadowPositions[i];
   let pelusa = new Pelusa2( 
       shadowPos.x, 
       shadowPos.y, 
       shadowSize, 
       colorPalette.background+"10", 
       0.001 ); 
   pelusa.draw();    
 }
 let layer = createLayer( 4, "Pelusa worn " );
}

function createGlobalPelusa(){
  // ------ PELUSA SHADOW BACKGROUND -------
 prepareLayer();
 shadowPositions = [
  {x:cX,y:cY}
 ];
 for (let i = 0; i < shadowPositions.length; i++) {
   let shadowPos = shadowPositions[i];
   let pelusa = new Pelusa2( 
       shadowPos.x, 
       shadowPos.y, 
       pieceWidth*.6, colorPalette.shadow+"05", 0.0005 ); 
   pelusa.draw();    
 }
 let layer = createLayer( 0, "Global Pelusa Shadow", 0.8 );
 drawFrame();
 layer.applyBlur( options.blurLevel1 );
}

window.acceptNotice = function(){
  console.log( 'acceptNotice', acceptNotice );
  hidePreloader();
}

function drawFrame(){
  if( !configOptions.frame ) return;
  pp.push();
  pp.noFill();
  pp.stroke(colorPalette.background);
  pp.strokeWeight(150);
  pp.rect(0,0,pieceWidth,pieceHeight);
  pp.pop();
}

function createBrancher(suffix){
  
  let brancher = new Brancher( options.brancherConfig );
  branchers.push( brancher );
  /* window.$fxhashFeatures["brancher"+suffix+"_numSegments"] = brancher.allSegments.length;
  window.$fxhashFeatures["brancher"+suffix+"_numPolygons"] = brancher.allPolygons.length; */
  return brancher;
}
// Main script here
const sketchSeed = ( sketch ) => {
  // This global variable is used by Genart library
  window.p5App = window.pp = sketch;  

  // Define p5's setup function
  sketch.setup = () => {
    init();
    
    //app.onFinished();
    //app.triggerImageGeneratedEvent(0.25);
    sketch.windowResized();
    const browser = detect();

    console.log( 'browser', browser );
    if( browser ){
      let infoText;
      if(browser.os == "iOS") {
        document.querySelector("#introMessage").innerHTML = "Device not fully supported<br/>Best on Chrome Desktop<br/>Art may differ<br/><button onclick=\"acceptNotice()\">OK</button>";
      }else if(browser.name == "safari") {
        document.querySelector("#introMessage").innerHTML = "Browser not fully supported<br/>Best on Chrome Desktop<br/>Art may differ<br/><button onclick=\"acceptNotice()\">OK</button>";
      }else{
        hidePreloader(); 
      }
    }else{
        hidePreloader(); 
    } 
    $fx.preview();
    
  };
  
  // Define p5's setup function
  sketch.draw = () => {
  };

  // Handle window resizing by scaling the artwork as needed
  sketch.windowResized = () => {  
    var scale;
    scale = Math.min(
      sketch.windowWidth / pieceWidth,    
      sketch.windowHeight / pieceHeight
    );
    let $el = document.querySelector("#defaultCanvas0");
    $el.style.transform = "" + "scale(" + scale + ")";
    window.canvasScale = scale;
  };
};

function showDownloader(){
  document.getElementById('downloaderBg').classList.add("downloaderVisible");
}
function hideDownloader(){
  document.getElementById('downloaderBg').classList.remove("downloaderVisible");
}
/**
 * Hides the preloader screen when the artwork is ready
*/
function hidePreloader(){
  document.getElementById('introMessage').remove();  
  document.getElementById('preloader').classList.add("hiddenPreloaderText");
  document.getElementById('preloaderBg').classList.add("hiddenPreloaderBg");
}


function applyFilters(){ 
  
  let ctx = p5App.drawingContext;    
  let filters = "";
  
  
  
  if( $fxhashFeatures.contrast != 1 )
  filters += "contrast("+ $fxhashFeatures.contrast +") ";
  
  if( $fxhashFeatures.saturate != 1 )
  filters += "saturate("+ $fxhashFeatures.saturate +") ";
  
  if( $fxhashFeatures.brightness != 1 )
  filters += "brightness("+ $fxhashFeatures.brightness +") ";
  
  if( filters )
    console.log( "Will apply filters: ", filters );

  ctx.filter = filters;
  ctx.drawImage( ctx.canvas, 0, 0, ctx.canvas.width*window.pixelDensity, ctx.canvas.height*window.pixelDensity, 0, 0, ctx.canvas.width, ctx.canvas.height);
  ctx.filter = `none`;

  
}



document.addEventListener('keydown', (event) => {
  var name = event.key;
  var code = event.code;
  console.log( "key pressed: ", name, " (", code, ")" );
  let validDensities = ["1","2","3","4"];
  if( validDensities.includes(name) ){
    updateResolutionAndSaveImage(name);
  }
  
  else if( code === 'KeyS' ){
    updateResolutionAndSaveImage(window.pixelDensity)
  }
  else if( code === 'KeyV' ){
    updateResolutionAndSaveImage("svg")
  }
  else if( code === 'KeyR' ){
    configOptions.grain = !configOptions.grain;
    init();
  }
  else if( code === 'KeyL' ){
    configOptions.glow = !configOptions.glow;
    init();
  }
  else if( code === 'KeyF' ){
    configOptions.frame = !configOptions.frame;
    init();
  }
  else if( code === 'KeyH' ){
    configOptions.shadow = !configOptions.shadow;
    init();
  }
  else if( code === 'KeyW' ){
    configOptions.worn = !configOptions.worn;
    init();
  }
  else if( code === 'KeyB' ){
    configOptions.backdropSketch = !configOptions.backdropSketch;
    init();
  }
}, false);

function updateResolutionAndSaveImage( density ){
  showDownloader();
  setTimeout(() => {
    if( density == "svg" ){
      buildSVG();      
    }else{
      if( window.pixelDensity != density ){
        window.pixelDensity = Number(density);
        init();
      }
      p5App.saveCanvas( "Obliqua__"+fxhash+'__x'+density);
    }
    setTimeout(() => {
      hideDownloader();
    }, 3000);
  }, 500);

}

function buildSVG(){
  let pg, brancher;
  for (let i = 0; i < branchers.length; i++) {
    brancher = branchers[i];
    pg = p5App.createGraphics( pieceWidth, pieceHeight, 'svg' );
    brancher.drawSegments( pg );
    pg.save("Obliqua__"+fxhash+'__Stroke_Layer_'+i);
    pg.remove()
  }
  pg = p5App.createGraphics( pieceWidth, pieceHeight, 'svg' );
  brancher = branchers[branchers.length-1];
  brancher.drawPolygons( pg, true );
  pg.save("Obliqua__"+fxhash+'__Fills');
  pg.remove()
}



// Start the party!

$fx.features(
  window.$fxhashFeatures
);
setTimeout( function(){
  new p5(sketchSeed);
}, 100 );